import {Route, Routes} from "react-router";
import UserList from "./user/UserList";
import UserNew from "./user/UserNew";
import UserEdit from "./user/UserEdit";
import RiskNew from "./risk/RiskNew";
import RiskEdit from "./risk/RiskEdit";
import RiskList from "./risk/RiskList";
import ConsejeriaList from "./consejeria/ConsejeriaList";
import ConsejeriaNew from "./consejeria/ConsejeriaNew";
import ConsejeriaEdit from "./consejeria/ConsejeriaEdit";
import HorarioList from "./horario/HorarioList";
import HorarioNew from "./horario/HorarioNew";
import HorarioEdit from "./horario/HorarioEdit";
import SinAtencionList from "./sinAtencion/SinAtencionList";
import SinAtencionNew from "./sinAtencion/SinAtencionNew";
import SinAtencionEdit from "./sinAtencion/SinAtencionEdit";
import RangoEdadNew from "./rangoEdad/RangoEdadNew";
import RangoEdadEdit from "./rangoEdad/RangoEdadEdit";
import RangoEdadList from "./rangoEdad/RangoEdadList";
import ProductoList from "./producto/ProductoList";
import ProductoNew from "./producto/ProductoNew";
import ProductoEdit from "./producto/ProductoEdit";
import PedidoList from "./pedidos/PedidoList";
import CitaList from "./citas/CitaList";
import CitaEdit from "./citas/CitaEdit";
import ClientList from "./client/ClientList";
import ClientNew from "./client/ClientNew";
import ClientEdit from "./client/ClientEdit";
import PdfList from "./pdf/PdfList";
import PdfRiskList from "./risk/pdf/PdfRiskList";
import PdfRiskNew from "./risk/pdf/PdfRiskNew";
import EnfermedadRiskList from "./risk/enfermedad/EnfermedadRiskList";
import ProductoRiskList from "./risk/productos/ProductoRiskList";
import ProductoRiskNew from "./risk/productos/ProductoRiskNew";
import ConsejeriaRiskList from "./risk/consejerias/ConsejeriaRiskList";
import ConsejeriaRiskNew from "./risk/consejerias/ConsejeriaRiskNew";
import CategoriaList from "./categoria/CategoriaList";
import CategoriaNew from "./categoria/CategoriaNew";
import CategoriaEdit from "./categoria/CategoriaEdit";
import DetallePedidoList from "./pedidos/detalle/DetallePedidoList";
import IngresoList from "./ingresos/IngresoList";

const MainRoutes = () =>{
  return (
    <Routes>
      <Route path="/usuarios" element={<UserList/>}/>
      <Route path="/usuarios/new" element={<UserNew/>}/>
      <Route path="/usuarios/edit/:id" element={<UserEdit/>}/>
      <Route path="/clientes" element={<ClientList/>}/>
      <Route path="/clientes/new" element={<ClientNew/>}/>
      <Route path="/clientes/edit/:id" element={<ClientEdit/>}/>
      <Route path={'/pdfs'} element={<PdfList/>}/>
      <Route path={'/riesgos'} element={<RiskList/>}/>
      <Route path={'/riesgos/new'} element={<RiskNew/>}/>
      <Route path={'/riesgos/edit/:id'} element={<RiskEdit/>}/>
      <Route path={'/riesgos/:id/pdfs'} element={<PdfRiskList/>}/>
      <Route path={'/riesgos/:id/pdfs/new'} element={<PdfRiskNew/>}/>
      <Route path={'/riesgos/:id/ponderacion'} element={<EnfermedadRiskList/>}/>
      <Route path={'/riesgos/:id/productos'} element={<ProductoRiskList/>}/>
      <Route path={'/riesgos/:id/productos/new'} element={<ProductoRiskNew/>}/>
      <Route path={'/riesgos/:id/consejerias'} element={<ConsejeriaRiskList/>}/>
      <Route path={'/riesgos/:id/consejerias/new'} element={<ConsejeriaRiskNew/>}/>
      <Route path={'/consejerias'} element={<ConsejeriaList/>}/>
      <Route path={'/consejerias/new'} element={<ConsejeriaNew/>}/>
      <Route path={'/consejerias/edit/:id'} element={<ConsejeriaEdit/>}/>
      <Route path={'/horario'} element={<HorarioList/>}/>
      <Route path={'/horario/new'} element={<HorarioNew/>}/>
      <Route path={'/horario/edit/:id'} element={<HorarioEdit/>}/>
      <Route path={'/sin-atencion'} element={<SinAtencionList/>}/>
      <Route path={'/sin-atencion/new'} element={<SinAtencionNew/>}/>
      <Route path={'/sin-atencion/edit/:id'} element={<SinAtencionEdit/>}/>
      <Route path={'/rango-edad'} element={<RangoEdadList/>}/>
      <Route path={'/rango-edad/new'} element={<RangoEdadNew/>}/>
      <Route path={'/rango-edad/edit/:id'} element={<RangoEdadEdit/>}/>
      <Route path={'/productos'} element={<ProductoList/>}/>
      <Route path={'/productos/new'} element={<ProductoNew/>}/>
      <Route path={'/productos/edit/:id'} element={<ProductoEdit/>}/>
      <Route path={'/categoria'} element={<CategoriaList/>}/>
      <Route path={'/categoria/new'} element={<CategoriaNew/>}/>
      <Route path={'/categoria/edit/:id'} element={<CategoriaEdit/>}/>
      <Route path={'/pedidos'} element={<PedidoList/>}/>
      <Route path={'/pedidos/:id/detalle'} element={<DetallePedidoList/>}/>
      {/*<Route path={'/pedidos/edit/:id'} element={<PedidoEdit/>}/>*/}
      <Route path={'/citas'} element={<CitaList/>}/>
      <Route path={'/citas/edit/:id/:idConsejeria'} element={<CitaEdit/>}/>
      <Route path={'/ingresos'} element={<IngresoList/>}/>
    </Routes>
  )
}

export default MainRoutes;
